import {
  Box,
  useTheme,
  Tabs,
  Tab,
} from '@mui/material';
import React, {
  useState,
} from 'react';
import { useCustomEventTracking } from '../../../common/useCustomEventTracking';
import { FeedInteractionAction } from '../../../common/models/content/Content';
import { TestIds } from '../../../assets/testIds';

interface FilterContentProps {
  title: string;
  options: string[];
  tag: string;
}

export function ContentFilters({
  filterContents,
  setSelectedFilter,
  initialFilter,
}: {
  filterContents: FilterContentProps[];
  setSelectedFilter: (filter: string) => void;
  // Tag of the tab to open on, e.g. when another page links to the Featured filter.
  initialFilter?: string;
}) {
  const theme = useTheme();
  const [value, setValue] = useState(() => Math.max(
    filterContents.findIndex((f) => f.tag === initialFilter),
    0,
  ));
  const { trackFeedInteraction } = useCustomEventTracking();

  const handleChange = (_: React.SyntheticEvent, newIndex: number) => {
    setValue(newIndex);
    setSelectedFilter(filterContents[newIndex].tag);
    trackFeedInteraction(
      'Filter',
      'Content',
      {
        action: FeedInteractionAction.Filter,
        filter: filterContents[newIndex].tag,
      },
    );
  };

  return (
    <Box sx={{
      width: '100%',
      mb: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
    }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="Content filters"
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.brand.primary,
          },
          '& .MuiTab-root': {
            ...theme.typography.body2,
            color: theme.palette.grey[600],
            '&.Mui-selected': {
              color: theme.palette.brand.primary,
            },
          },
        }}
      >
        {filterContents.map((f) => (
          <Tab key={f.tag} label={f.title} data-testid={`${TestIds.contentFeed.filterTabPrefix}-${f.tag}`} />
        ))}
      </Tabs>
    </Box>
  );
}
